import React from 'react'

const Company = () => {
  return (
    <div class="container-xxl flex-grow-1 container-p-y">
        <h2 className='card-title'>Company / <span style={{color:'#00b4d8'}} className='card-title'>Company A</span></h2>

        <div className='row mt-5'>
            <div className='col-8'>
                <h2 style={{color:'black'}}>Projects</h2>
            </div>
            <div className='col-2'>
            <button class="btn btn-primary m-3" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasEnd" aria-controls="offcanvasEnd" >
              <i class="fa-sharp fa-solid fa-plus fa-lg me-3" style={{color:'white'}}></i>Add new</button>
            </div>
            <div className='col-2'>
            <button class="btn btn-primary m-3" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasEnd" aria-controls="offcanvasEnd" >
              <i class="fa-sharp fa-solid fa-plus fa-lg me-3" style={{color:'white'}}></i>Add new</button>
            </div>
        </div>


        <div class="row" style={{justifyContent:'space-evenly',marginTop:30}}>

            <div class="col-lg-5 col-md-5 col-5 mb-4">
            <div class="card">
                <div class="card-body">
                    <div className='row'>
                        <div className='col-9'>
                        <h5 class="card-title mb-2">Project 1</h5>
                        </div>
                        <div className='col-3'>
                        <h7>$ 100,000</h7>
                        </div>
                    </div>
                    <h6 style={{color:'black',marginBottom:5}}>Timeline</h6>
                    <p>2023/02/01 - 2023/04/01</p>
                    <h6 style={{color:'black',marginBottom:5}}>Priority <span style={{background:'#FDAFBC',color:'red',padding:3,marginLeft:50,borderRadius:5}}>Low</span></h6>
                    <h6 style={{color:'black',marginBottom:5,marginTop:20}}>Assigned to <span style={{background:'#73B8FC',color:'blue',padding:3,marginLeft:20,borderRadius:5}}>Aimable RUKUNDO</span></h6>
                </div>
            </div>
            </div>

            <div class="col-lg-5 col-md-5 col-5 mb-4">
            <div class="card">
                <div class="card-body">
                    <div className='row'>
                        <div className='col-9'>
                        <h5 class="card-title mb-2">Project 1</h5>
                        </div>
                        <div className='col-3'>
                        <h7>$ 100,000</h7>
                        </div>
                    </div>
                    <h6 style={{color:'black',marginBottom:5}}>Timeline</h6>
                    <p>2023/02/01 - 2023/04/01</p>
                    <h6 style={{color:'black',marginBottom:5}}>Priority <span style={{background:'#FDAFBC',color:'red',padding:3,marginLeft:50,borderRadius:5}}>Low</span></h6>
                    <h6 style={{color:'black',marginBottom:5,marginTop:20}}>Assigned to <span style={{background:'#73B8FC',color:'blue',padding:3,marginLeft:20,borderRadius:5}}>Aimable RUKUNDO</span></h6>
                </div>
            </div>

            </div>
            <div class="col-lg-5 col-md-5 col-5 mb-4">
            <div class="card">
                <div class="card-body">
                    <div className='row'>
                        <div className='col-9'>
                        <h5 class="card-title mb-2">Project 1</h5>
                        </div>
                        <div className='col-3'>
                        <h7>$ 100,000</h7>
                        </div>
                    </div>
                    <h6 style={{color:'black',marginBottom:5}}>Timeline</h6>
                    <p>2023/02/01 - 2023/04/01</p>
                    <h6 style={{color:'black',marginBottom:5}}>Priority <span style={{background:'#FDAFBC',color:'red',padding:3,marginLeft:50,borderRadius:5}}>Low</span></h6>
                    <h6 style={{color:'black',marginBottom:5,marginTop:20}}>Assigned to <span style={{background:'#73B8FC',color:'blue',padding:3,marginLeft:20,borderRadius:5}}>Aimable RUKUNDO</span></h6>
                </div>
            </div>
            </div>

            <div class="col-lg-5 col-md-5 col-5 mb-4">
            <div class="card">
                <div class="card-body">
                    <div className='row'>
                        <div className='col-9'>
                        <h5 class="card-title mb-2">Project 1</h5>
                        </div>
                        <div className='col-3'>
                        <h7>$ 100,000</h7>
                        </div>
                    </div>
                    <h6 style={{color:'black',marginBottom:5}}>Timeline</h6>
                    <p>2023/02/01 - 2023/04/01</p>
                    <h6 style={{color:'black',marginBottom:5}}>Priority <span style={{background:'#FDAFBC',color:'red',padding:3,marginLeft:50,borderRadius:5}}>Low</span></h6>
                    <h6 style={{color:'black',marginBottom:5,marginTop:20}}>Assigned to <span style={{background:'#73B8FC',color:'blue',padding:3,marginLeft:20,borderRadius:5}}>Aimable RUKUNDO</span></h6>
                </div>
            </div>
            </div>

            <div class="col-lg-5 col-md-5 col-5 mb-4">
            <div class="card">
                <div class="card-body">
                    <div className='row'>
                        <div className='col-9'>
                        <h5 class="card-title mb-2">Project 1</h5>
                        </div>
                        <div className='col-3'>
                        <h7>$ 100,000</h7>
                        </div>
                    </div>
                    <h6 style={{color:'black',marginBottom:5}}>Timeline</h6>
                    <p>2023/02/01 - 2023/04/01</p>
                    <h6 style={{color:'black',marginBottom:5}}>Priority <span style={{background:'#FDAFBC',color:'red',padding:3,marginLeft:50,borderRadius:5}}>Low</span></h6>
                    <h6 style={{color:'black',marginBottom:5,marginTop:20}}>Assigned to <span style={{background:'#73B8FC',color:'blue',padding:3,marginLeft:20,borderRadius:5}}>Aimable RUKUNDO</span></h6>
                </div>
            </div>
            </div>

            <div class="col-lg-5 col-md-5 col-5 mb-4">
            <div class="card">
                <div class="card-body">
                    <div className='row'>
                        <div className='col-9'>
                        <h5 class="card-title mb-2">Project 1</h5>
                        </div>
                        <div className='col-3'>
                        <h7>$ 100,000</h7>
                        </div>
                    </div>
                    <h6 style={{color:'black',marginBottom:5}}>Timeline</h6>
                    <p>2023/02/01 - 2023/04/01</p>
                    <h6 style={{color:'black',marginBottom:5}}>Priority <span style={{background:'#FDAFBC',color:'red',padding:3,marginLeft:50,borderRadius:5}}>Low</span></h6>
                    <h6 style={{color:'black',marginBottom:5,marginTop:20}}>Assigned to <span style={{background:'#73B8FC',color:'blue',padding:3,marginLeft:20,borderRadius:5}}>Aimable RUKUNDO</span></h6>
                </div>
            </div>
            </div>

            

        </div>
    </div>
  )
}

export default Company;